import { Row, Col, Badge } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";
import { useEffect, useRef, useState } from "react";
import { Table } from "components";
import { getStores } from "redux/slices/Stores";
import { StoresPopup } from "popups/Stores/Stores";
import { updateCatalogueField, getCatalogueStores, addSelectedStores, updateCatalogueModelField, addAGGridSelectedStores } from "redux/slices/Catalogues";
import { getRowIds } from "helpers/data/dataHandling";
import { getCatalogueStoresConfig } from "TableConfigs/CatalogueStoreConfig";
import { AgGridToolbar, AgGridToolbarRef } from "components/AgGrid/AgGridToolbar";
import { ZTooltip } from "components/ZTooltip";
import { Z } from "models/common/components";
import { ZIconType } from "helpers/utility/iconMap";
import { AgGridReact } from "ag-grid-react";
import BaseCellRenderer from "components/AgGrid/CellRenderers/BaseCellRenderer";
import { CatalogueDeletePopup } from "../Popups/CatalogueDeletePopup";


export default function Stores() {
    const dispatch = useAppDispatch();
    const catelogueStoreGridRef = useRef<AgGridReact>(null);
    const user = useAppSelector((state: RootState) => state.logedinUser);
    const toolbarRef = useRef<AgGridToolbarRef>(null);
    const stores = useAppSelector((state: RootState) => state.stores);
    const catalogue = useAppSelector((state: RootState) => state.catalogues);
    const currentStoreGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);
    const [allowedStoreIds, setAllowedStoreIds] = useState<number[]>([]);
    const [visibleStores, setVisisbleStores] = useState<any[]>([]);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [isDeletingSelectedStore, setIsDeletingSelectedStore] = useState(false);

    useEffect(() => {
        if (catalogue.model.catalogueId && catalogue.model.stores.length > 0) {
            getAllowedStores();
            dispatch(getCatalogueStores({ ids: [catalogue.model.catalogueId], stores: catalogue.model.stores }));
        }
       
    }, [currentStoreGroupId, catalogue.model.catalogueId]);


    useEffect(() => {
        setAllowedStoreIds(catalogue.allowedStores.map((i: any) => i.id));
    }, [catalogue.allowedStores]);

    useEffect(() => {
        const table: any[] = [];
        catalogue.allowedStores.forEach((store: any) => {
            if(catalogue.model.stores.includes(store.id as never)) table.push(store);
        });
        setVisisbleStores(table);
        if(table.length == 0 && catelogueStoreGridRef.current != null && catelogueStoreGridRef.current?.api != undefined)
            catelogueStoreGridRef.current?.api.showNoRowsOverlay();
    }, [catalogue.stores, allowedStoreIds]);


    async function getAllowedStores(){
        await dispatch(getStores({ storeGroupIds: [currentStoreGroupId] })).then((res) => {
            if( res.data.length > 0)  dispatch(updateCatalogueField({ key: "allowedStores", value: res.data }));
        });
    }

    function handleChange(option: any, optionValue: any) {
        dispatch(updateCatalogueField({ key: option, value: optionValue }));
    }

    function onGridReady(){
        if(visibleStores.length == 0)
            catelogueStoreGridRef.current?.api.showNoRowsOverlay();
    }

    function handleStoreDelete() {
        setIsDeletingSelectedStore(true);
        let stores: any[] = [];
        catalogue.stores.forEach((store: any, index) => {
            if (catalogue.selectedStores.filter((i) => i.id==store.storeId).length == 0) 
                stores.push(catalogue.stores[index]);
        });
        let storeList: any[] = stores.map(i => i.storeId);
        updateStoreDetailImport(storeList, stores);
        setIsDeletingSelectedStore(false);
        setShowDeletePopup(false);
    }

    async function storesPopupSave() {
        if(catalogue.model.stores.length === 0) await getAllowedStores(); 
        let selectedStores: any[] = [];
        let deseledStores: any[] = [];
        let storeList: any[] = [...catalogue.model.stores];
        let newStores: any[] = [...catalogue.stores];

        selectedStores = getRowIds(stores.selectedRows);
        deseledStores = getRowIds(stores.deselectedRows);

        async function createNewStores(store: number) {
            if (!storeList.includes(store as never)) storeList.push(store);
            if (!catalogue.selectedStores.map((i: any) => i.id).includes(store)) selectedStores.push(store);
            let match = catalogue.allowedStores.find((s: any) => s.id === store) as any;
            if (match && !catalogue.model.stores.includes(store as never)) {
                newStores.push({
                    name: match.name,
                    storeId: match.id,
                    id: match.id,
                    lines: 0
                });
            }
        }
        
        if (stores.selectAllFilter) {
            await dispatch(getStores({ storeGroupIds: [currentStoreGroupId] })).then(async (res) => {
                const storeIds = res.data.map((i: any) => i.id);
                await storeIds.forEach((element: number) => {
                    if(!deseledStores.includes(element)) createNewStores(element);
                });
            });
        } else {
            selectedStores.forEach(async (store: number) => await createNewStores(store));
        }

        await updateStoreDetailImport(storeList, newStores);
        handleChange("storesPopup", false);
    }

    async function updateStoreDetailImport(storeList: any[], newStores: any[]) {
        dispatch(updateCatalogueModelField({ key: "stores", value: storeList }));
        dispatch(updateCatalogueField({ key: "stores", value: newStores }));
    }

    return (
        <Row>
            <Col xs={12}>
                <StoresPopup show={catalogue.storesPopup} onClose={() => handleChange("storesPopup", false)} onSave={storesPopupSave} />
                <AgGridToolbar
                    search={false}
                    ref={toolbarRef}
                    className="pb-1"
                    children={(                        
                        <div className="d-inline-flex gap-1 w-100">
                            <div className="w-100">
                                <h5 className="mb-0 fw-bold pt-3">Stores</h5>
                            </div>
                             { 
                            (catalogue.selectedStores != undefined && catalogue.selectedStores.length != 0) &&									
                                <Z.Button variant="light" className="h-100" disabled={true} buttonText={catalogue.selectedStores.length + " Selected"}/>
                            }
                            <ZTooltip text="Add Stores">
                                <Z.Button
                                    size="sm"
                                    className="btn-icon custom-btn-icon "
                                    onClick={user.permissions.priceGroups.canImport ? () => handleChange("storesPopup", true) : undefined}
                                    disabled={!user.permissions.promotions.canCreate || !user.permissions.promotions.canUpdate} 
                                    icon={ZIconType.Add}
                                    iconSize="18px"
                                    style={{height: 40}}/>
                            </ZTooltip>
                            <ZTooltip text={
                                    catalogue.selectedStores.length == 0 ? `Please select a row to delete`:										  
                                    catalogue.selectedStores.length > 0 ? `Delete ${catalogue.selectedStores.length} rows` :
                                    catalogue.selectedStores.length == catalogue.model.catalogueStocks.length ? `Delete all rows`:
                                        "Please select a row to delete"}>
                                    <Z.Button icon={ZIconType.Delete} buttonSize="md"  onClick={() => (user.permissions.promotions.canDelete ? setShowDeletePopup(true) : undefined)} 
                                        disabled={!user.permissions.promotions.canDelete || catalogue.selectedStores.length < 1 } />
                                </ZTooltip>
                        </div>
                    )}
                />
                <AgGridReact
                    ref={catelogueStoreGridRef}                                    
                    columnDefs={getCatalogueStoresConfig(stores, catalogue)}
                    rowData={ visibleStores != undefined && visibleStores.length != 0? visibleStores: null }
                    pagination={true}
                    paginationPageSize={20}
                    containerStyle={{ height: "57dvh" }}
                    className="ag-theme-quartz ag-theme-custom w-100"
                    rowSelection="multiple"
                    suppressRowClickSelection={true}
                    suppressCellFocus={true}
                    suppressContextMenu
                    onGridReady={onGridReady}
                    onSelectionChanged={(e) => {
                        let formatedData:{
                            positon: number,
                            id: number
                        } [] = []
                        catelogueStoreGridRef.current?.api.getSelectedRows().forEach((xe: any) => formatedData.push({ positon: 0, id: xe.id}));
                        dispatch(addAGGridSelectedStores(formatedData));
                    }}
                    onRowSelected={() => {
                        let formatedData:{
                            positon: number,
                            id: number
                        } [] = []
                        catelogueStoreGridRef.current?.api.getSelectedRows().forEach((xe: any) => formatedData.push({ positon: 0, id: xe.id}));
                        dispatch(addAGGridSelectedStores(formatedData));
                    }}
                    components={{
                        baseCellRenderer: BaseCellRenderer,
                    }}
                />
            </Col>
            <CatalogueDeletePopup
                isDeleting = {isDeletingSelectedStore}
                showPopup = {showDeletePopup}
                selectedRowsCount = {catalogue.selectedStocks.length}
                closeDeletePopup = {()=> setShowDeletePopup(false)}
                ActionDelete = {() => (user.permissions.managedStock.canDelete ? handleStoreDelete() : undefined)}
            />
        </Row>
    );
}